import { createContext, ReactNode, useContext } from "react";
import { Group } from "../entities/group.types";
import { useGroupSelect } from "../hooks/group-select/group-select";

export interface GroupsContextType {
  groups: Group[];
  selectedGroupValue: (groupId: number) => string | undefined;
  selectedGroupValueWithName: (groupId: number) => Group | undefined;
  isLoadingGroups: boolean;
}

const GroupsContext = createContext<GroupsContextType | undefined>(undefined);

export const GroupsProvider = ({ children }: { children: ReactNode }) => {
  const { data } = useGroupSelect();

  return (
    <GroupsContext.Provider value={data}>{children}</GroupsContext.Provider>
  );
};

export const useGroups = () => {
  const context = useContext(GroupsContext);
  if (context === undefined) {
    throw new Error("useGroups must be used within a GroupsProvider");
  }
  return context;
};
